module.exports = __webpack_public_path__ + "img/t1.2ca7475f.jpg";